export default "__VITE_ASSET__158ca0f1__"